import Dialog from "./classes/Dialog.js";
import {
    lookup,
    lookupOne,
    lookupOneCached
} from "./utils/elements.js";
import QRCode from "./lib/qrcode-svg.js";
import renderSheet from "./processes/sheet/render.js";

// Render the character groups and jinxes client-side (no PHP backend).
renderSheet();

// Generate the QR code.
lookupOne("#qr-code").append(QRCode({
    msg: window.location.href,
    ecl: "L"
}));

// Activate the dialogs.
lookup("[data-dialog]").forEach((trigger) => {
    trigger.dialog = Dialog.createFromTrigger(trigger);
});

// Force the details to be open when printing. The details are added
// dynamically by renderSheet(), so query live rather than from the cache.
function openAllDetails() {

    lookup(".details").forEach((details) => {

        if (details.dataset.open) {
            return;
        }

        details.dataset.open = details.open;
        details.open = true;

    });

}

function closeDetails() {

    lookup(".details").forEach((details) => {

        if (!details.dataset.open) {
            return;
        }

        details.open = details.dataset.open === "true";
        delete details.dataset.open;

    });

}

const printQuery = window.matchMedia("print");
printQuery.addEventListener("change", ({ matches }) => {

    if (matches) {
        openAllDetails();
    } else {
        closeDetails();
    }

});

if (printQuery.matches) {
    openAllDetails();
}

window.addEventListener("beforeprint", openAllDetails);
window.addEventListener("afterprint", closeDetails);

// Change Language. The static locale options only contain the page path, so
// carry the current query string (?characters=, ?name=, ...) across.
lookup("#select-locale option").forEach((option) => {
    if (option.value) {
        option.value += window.location.search;
    }
});
lookupOne("#locale-form").addEventListener("submit", (e) => {
    e.preventDefault();
    window.location.href = lookupOneCached("#select-locale").value;
});
lookupOneCached("#select-locale").addEventListener("change", ({ target }) => {
    target.form.requestSubmit();
});
